module.exports = __webpack_public_path__ + "static/media/image5.7e244570.jpg";